import { addMethod } from 'yup';
export function enrich(object) {
    addMethod(object, 'minProperties', function (minProperties) {
        return this.test('min-properties', `Object in path: \${path} does not satisfy minimum number of properties: ${minProperties}`, schema => {
            const properties = schema ? Object.keys(schema).length : 0;
            return properties >= minProperties;
        });
    });
    addMethod(object, 'maxProperties', function (maxProperties) {
        return this.test('max-properties', `Object in path: \${path} does not satisfy maximum number of properties: ${maxProperties}`, schema => {
            const properties = schema ? Object.keys(schema).length : 0;
            return properties <= maxProperties;
        });
    });
}
//# sourceMappingURL=yupEnrichment.js.map